import Tabs, { Tab as SkapaTab, TabPanel } from "@ingka/tabs";
import styles from "./TabNav.module.css";

export interface Tab {
    id: string;
    label: string;
    badge?: string | number;
    badgeLoading?: boolean;
    badgeError?: boolean;
    tooltip?: string;
}

interface TabNavProps {
    tabs: Tab[];
    activeTab: string;
    onTabChange: (tabId: string) => void;
    children?: React.ReactNode;
}

export function TabNav({ tabs, activeTab, onTabChange, children }: TabNavProps) {
    return (
        <Tabs className={styles.tabs}
            tabs={tabs.map((tab) => (
                <SkapaTab
                    key={tab.id}
                    tabPanelId={tab.id}
                    text={
                        <span className={styles.tabLabel}>
                            {tab.label}
                            {tab.badgeLoading ? (
                                <span className={`${styles.badge} ${activeTab === tab.id ? styles.badgeActive : ""}`}>
                                    <span className={styles.badgeSpinner} />
                                </span>
                            ) : tab.badgeError ? (
                                <span className={`${styles.badge} ${styles.badgeError}`} title="Failed to load">!</span>
                            ) : tab.badge !== undefined ? (
                                <span className={`${styles.badge} ${activeTab === tab.id ? styles.badgeActive : ""}`} title={tab.tooltip || "Attach rate: percentage of combinations that include this component"}>
                                    {tab.badge}
                                </span>
                            ) : null}
                        </span>
                    }
                    title={tab.tooltip}
                />
            ))}
            tabPanels={[
                <TabPanel key={activeTab} tabPanelId={activeTab} className={styles.tabPanel}>
                    {children}
                </TabPanel>,
            ]}
            activeTab={activeTab}
            onTabChanged={onTabChange}
        />
    );
}
